import { msg } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { RequestStatus } from '@sel/shared';
import { LinkButton } from '@sel/ui';
import z from 'zod';

import { routes } from 'src/app/routes';
import { Link } from 'src/components/link';
import { PageTitle } from 'src/components/page-title';
import { useDebouncedValue } from 'src/hooks/use-debounced-value';
import { useFilters } from 'src/hooks/use-filters';

import { RequestFiltersBar } from './requests-filters';
import { RequestList } from './requests-list';

const filtersSchema = z.object({
  status: z.enum([RequestStatus.pending, 'all']).catch(RequestStatus.pending),
  search: z.string().catch(''),
  mine: z.stringbool().catch(false),
});

export function RequestsPage() {
  const { filters, setFilters, hasFilters, resetFilters } = useFilters(filtersSchema);

  const [search, setSearch, clearSearch] = useDebouncedValue(filters.search, (value) =>
    setFilters({ search: value }, { replace: true }),
  );

  const clearFilters = () => {
    clearSearch();
    resetFilters();
  };

  return (
    <div className="stack gap-6">
      <PageTitle title={msg`Requests`} />

      <header className="row flex-wrap items-center justify-between gap-4">
        <h1 className="text-title-1">
          <Trans>Requests</Trans>
        </h1>

        <LinkButton Link={Link} href={routes.createRequest()} icon="add" className="max-sm:w-full xl:w-aside">
          <Trans>New request</Trans>
        </LinkButton>
      </header>

      <div className="stack gap-6 xl:flex-row-reverse xl:items-start xl:gap-10">
        <aside className="xl:sticky xl:top-10 xl:w-aside xl:shrink-0">
          <RequestFiltersBar filters={filters} search={search} onSearch={setSearch} onChange={setFilters} />
        </aside>

        <div className="min-w-0 flex-1">
          <RequestList filters={filters} hasFilters={hasFilters} onClearFilters={clearFilters} />
        </div>
      </div>
    </div>
  );
}
